export default "/images/603d7eb894eaec8ccc33b96e739931b7.avif";